import { render } from "./expenses-category.vue?vue&type=template&id=8847c696"
import script from "./expenses-category.vue?vue&type=script&lang=js"
export * from "./expenses-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__